import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';

export const signOut = () => () => {
    window.location = AuthenticatedPaths.LOGOUT;
};
